import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  es: {
    // Navigation
    'nav.home': 'Inicio',
    'nav.about': 'Nosotros',
    'nav.howItWorks': 'Cómo Funciona',
    'nav.opportunities': 'Oportunidades',
    'nav.submitProperty': 'Aportar Inmueble',
    'nav.contact': 'Contacto',
    'nav.login': 'Iniciar Sesión',
    'nav.register': 'Registrarse',
    'nav.dashboard': 'Panel',
    'nav.profile': 'Perfil',
    'nav.documents': 'Documentos',
    'nav.settings': 'Configuración',
    'nav.logout': 'Cerrar Sesión',
    
    // Hero
    'hero.title': 'Inversión Inmobiliaria Blindada',
    'hero.subtitle': 'Acceda a oportunidades de inversión inmobiliaria de grado institucional, cuidadosamente seleccionadas y estructuradas con disciplina y transparencia.',
    'hero.cta.explore': 'Explorar Oportunidades',
    'hero.cta.submit': 'Aportar Inmueble',
    
    // Auth
    'auth.login': 'Iniciar Sesión',
    'auth.register': 'Crear Cuenta',
    'auth.email': 'Correo Electrónico',
    'auth.password': 'Contraseña',
    'auth.name': 'Nombre Completo',
    'auth.confirmPassword': 'Confirmar Contraseña',
    'auth.forgotPassword': '¿Olvidó su contraseña?',
    'auth.noAccount': '¿No tiene cuenta?',
    'auth.hasAccount': '¿Ya tiene cuenta?',
    'auth.magicLink': 'Enviar enlace mágico',
    'auth.googleLogin': 'Continuar con Google',
    'auth.or': 'o',
    'auth.registerAs': 'Registrarse como',
    'auth.investor': 'Inversionista',
    'auth.propertyContributor': 'Aportador de Inmueble',
    
    // Dashboard
    'dashboard.welcome': 'Bienvenido',
    'dashboard.profileCompletion': 'Completitud del Perfil',
    'dashboard.verificationStatus': 'Estado de Verificación',
    'dashboard.openOpportunities': 'Oportunidades Abiertas',
    'dashboard.myCommitments': 'Mis Compromisos',
    'dashboard.myDocuments': 'Mis Documentos',
    'dashboard.pendingActions': 'Acciones Pendientes',
    
    // Opportunities
    'opportunities.title': 'Oportunidades de Inversión',
    'opportunities.subtitle': 'Explore nuestras oportunidades de inversión inmobiliaria cuidadosamente estructuradas.',
    'opportunities.featured': 'Destacadas',
    'opportunities.all': 'Todas',
    'opportunities.filter': 'Filtrar',
    'opportunities.minInvestment': 'Inversión Mínima',
    'opportunities.targetReturn': 'Retorno Objetivo',
    'opportunities.status': 'Estado',
    'opportunities.viewDetails': 'Ver Detalles',
    'opportunities.invest': 'Invertir',
    
    // Property
    'property.submit': 'Aportar Inmueble',
    'property.title': 'Título del Inmueble',
    'property.type': 'Tipo de Inmueble',
    'property.address': 'Dirección',
    'property.city': 'Ciudad',
    'property.state': 'Estado',
    'property.landArea': 'Superficie de Terreno (m²)',
    'property.builtArea': 'Superficie Construida (m²)',
    'property.askingValue': 'Valor Solicitado',
    
    // Status
    'status.pending': 'Pendiente',
    'status.approved': 'Aprobado',
    'status.rejected': 'Rechazado',
    'status.inReview': 'En Revisión',
    'status.moreInfoRequired': 'Información Adicional Requerida',
    'status.open': 'Abierto',
    'status.closed': 'Cerrado',
    'status.draft': 'Borrador',
    
    // Common
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.submit': 'Enviar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.view': 'Ver',
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.success': 'Éxito',
    'common.required': 'Requerido',
    'common.optional': 'Opcional',
    'common.back': 'Volver',
    'common.next': 'Siguiente',
    'common.previous': 'Anterior',
    'common.search': 'Buscar',
    'common.noResults': 'No se encontraron resultados',
    
    // Legal
    'legal.disclaimer': 'Aviso Legal',
    'legal.riskWarning': 'La inversión en bienes raíces conlleva riesgos, incluyendo la posible pérdida de capital. Las proyecciones son estimaciones y no garantías.',
    'legal.terms': 'Términos y Condiciones',
    'legal.privacy': 'Política de Privacidad',
    'legal.riskDisclosures': 'Avisos de Riesgo',
    
    // Footer
    'footer.rights': 'Todos los derechos reservados.',
    'footer.company': 'Silver Brick Development',
  },
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.howItWorks': 'How It Works',
    'nav.opportunities': 'Opportunities',
    'nav.submitProperty': 'Submit Property',
    'nav.contact': 'Contact',
    'nav.login': 'Login',
    'nav.register': 'Register',
    'nav.dashboard': 'Dashboard',
    'nav.profile': 'Profile',
    'nav.documents': 'Documents',
    'nav.settings': 'Settings',
    'nav.logout': 'Logout',
    
    // Hero
    'hero.title': 'Institutional Real Estate Investment',
    'hero.subtitle': 'Access institutional-grade real estate investment opportunities, carefully selected and structured with discipline and transparency.',
    'hero.cta.explore': 'Explore Opportunities',
    'hero.cta.submit': 'Submit Property',
    
    // Auth
    'auth.login': 'Login',
    'auth.register': 'Create Account',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full Name',
    'auth.confirmPassword': 'Confirm Password',
    'auth.forgotPassword': 'Forgot password?',
    'auth.noAccount': "Don't have an account?",
    'auth.hasAccount': 'Already have an account?',
    'auth.magicLink': 'Send magic link',
    'auth.googleLogin': 'Continue with Google',
    'auth.or': 'or',
    'auth.registerAs': 'Register as',
    'auth.investor': 'Investor',
    'auth.propertyContributor': 'Property Contributor',
    
    // Dashboard
    'dashboard.welcome': 'Welcome',
    'dashboard.profileCompletion': 'Profile Completion',
    'dashboard.verificationStatus': 'Verification Status',
    'dashboard.openOpportunities': 'Open Opportunities',
    'dashboard.myCommitments': 'My Commitments',
    'dashboard.myDocuments': 'My Documents',
    'dashboard.pendingActions': 'Pending Actions',
    
    // Opportunities
    'opportunities.title': 'Investment Opportunities',
    'opportunities.subtitle': 'Explore our carefully structured real estate investment opportunities.',
    'opportunities.featured': 'Featured',
    'opportunities.all': 'All',
    'opportunities.filter': 'Filter',
    'opportunities.minInvestment': 'Minimum Investment',
    'opportunities.targetReturn': 'Target Return',
    'opportunities.status': 'Status',
    'opportunities.viewDetails': 'View Details',
    'opportunities.invest': 'Invest',
    
    // Property
    'property.submit': 'Submit Property',
    'property.title': 'Property Title',
    'property.type': 'Property Type',
    'property.address': 'Address',
    'property.city': 'City',
    'property.state': 'State',
    'property.landArea': 'Land Area (m²)',
    'property.builtArea': 'Built Area (m²)',
    'property.askingValue': 'Asking Value',
    
    // Status
    'status.pending': 'Pending',
    'status.approved': 'Approved',
    'status.rejected': 'Rejected',
    'status.inReview': 'In Review',
    'status.moreInfoRequired': 'More Info Required',
    'status.open': 'Open',
    'status.closed': 'Closed',
    'status.draft': 'Draft',
    
    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.submit': 'Submit',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.view': 'View',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.required': 'Required',
    'common.optional': 'Optional',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.search': 'Search',
    'common.noResults': 'No results found',
    
    // Legal
    'legal.disclaimer': 'Legal Disclaimer',
    'legal.riskWarning': 'Investment in real estate involves risk, including possible loss of capital. Projections are estimates and are not guaranteed.',
    'legal.terms': 'Terms and Conditions',
    'legal.privacy': 'Privacy Policy',
    'legal.riskDisclosures': 'Risk Disclosures',
    
    // Footer
    'footer.rights': 'All rights reserved.',
    'footer.company': 'Silver Brick Development',
  }
};

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('language') || 'es';
    }
    return 'es';
  });

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['es']?.[key] || key;
  }, [language]);

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', lang);
    }
  }, []);

  const formatCurrency = useCallback((amount, currency = 'MXN') => {
    const locale = language === 'es' ? 'es-MX' : 'en-US';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }, [language]);

  const formatDate = useCallback((date) => {
    const locale = language === 'es' ? 'es-MX' : 'en-US';
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(new Date(date));
  }, [language]);

  const formatNumber = useCallback((num) => {
    const locale = language === 'es' ? 'es-MX' : 'en-US';
    return new Intl.NumberFormat(locale).format(num);
  }, [language]);

  return (
    <I18nContext.Provider value={{ 
      language, 
      setLanguage: changeLanguage, 
      t, 
      formatCurrency, 
      formatDate,
      formatNumber 
    }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};

export default I18nContext;
